import apiProxy from "@shared/utils/api-proxy.ts";
import { PartnerCompanyNamesResponse } from "@shared/services/salesforce/partnerCompanyNames/response.ts";

export default async () => {
  const partnerCompanyNamesResponse: Record<string, unknown> | null =
    await apiProxy.get(`salesforce/partnerCompanyNames`);

  if (!partnerCompanyNamesResponse) {
    throw new Error("Got no response from server");
  }

  return partnerCompanyNamesResponse as PartnerCompanyNamesResponse;
};
